// extracted by mini-css-extract-plugin
module.exports = {"SocialIcon":"SocialShare_SocialIcon__1SZU7","ShareTitle":"SocialShare_ShareTitle__QIv-O"};